/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Engagement_Today_DoneInputs */

const en_us2_engagement_today_done = /** @type {(inputs: Engagement_Today_DoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Today's workout is done. Recovering is part of training too.`)
};

const pt_br2_engagement_today_done = /** @type {(inputs: Engagement_Today_DoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Treino de hoje feito. Recuperar também faz parte do treino.`)
};

const es_419_engagement_today_done = /** @type {(inputs: Engagement_Today_DoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entrenamiento de hoy listo. Recuperarse también es parte del entrenamiento.`)
};

const pt_pt2_engagement_today_done = /** @type {(inputs: Engagement_Today_DoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Treino de hoje feito. Recuperar também faz parte do treino.`)
};

const fr_fr2_engagement_today_done = /** @type {(inputs: Engagement_Today_DoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Séance du jour terminée. Récupérer fait aussi partie de l'entraînement.`)
};

const de_de2_engagement_today_done = /** @type {(inputs: Engagement_Today_DoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Das heutige Training ist erledigt. Erholung gehört auch zum Training.`)
};

const it_it2_engagement_today_done = /** @type {(inputs: Engagement_Today_DoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Allenamento di oggi fatto. Anche recuperare fa parte dell'allenamento.`)
};

/**
* | output |
* | --- |
* | "Today's workout is done. Recovering is part of training too." |
*
* @param {Engagement_Today_DoneInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const engagement_today_done = /** @type {((inputs?: Engagement_Today_DoneInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Engagement_Today_DoneInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_engagement_today_done(inputs)
	if (locale === "es-419") return es_419_engagement_today_done(inputs)
	if (locale === "pt-PT") return pt_pt2_engagement_today_done(inputs)
	if (locale === "fr-FR") return fr_fr2_engagement_today_done(inputs)
	if (locale === "de-DE") return de_de2_engagement_today_done(inputs)
	if (locale === "it-IT") return it_it2_engagement_today_done(inputs)
	return en_us2_engagement_today_done(inputs)
});
export { engagement_today_done as "engagement.today_done" }